var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0605 23.9746C7.36014 24.6754 6.22516 24.6749 5.52527 23.9746C4.82491 23.2742 4.82491 22.1392 5.52527 21.4393L21.939 5.02561C22.6393 4.3248 23.7743 4.3248 24.4742 5.02561C25.1755 5.72597 25.1746 6.86095 24.4742 7.56084L8.0605 23.9746Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52527 7.56084C4.82491 6.86095 4.82491 5.7255 5.52527 5.02561C6.22562 4.3248 7.36061 4.3248 8.0605 5.02561L24.4742 21.4387C25.1755 22.1391 25.1755 23.2741 24.4742 23.974C23.7739 24.6748 22.6389 24.6743 21.939 23.974L5.52527 7.56084Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/No.c52a6ad0ae2c6ce45db4d453ba7f2b83.svg";
export { ForwardRef as ReactComponent };